export enum StorageKey {
  SkipDbeCache = 'skip-dbe-cache',
  SkipMwCache = 'skip-mw-cache',
  SkipShareOfPostingsScaling = 'skip_share_of_postings_scaling',
  UserPreferencesPrefix = 'user-preferences-',
}
